<template>
    <body>
        <!-- <div class="mainview_div web_apphm_mainview_div position_fixed"> -->
        <div class="mainview_div web_apphm_mainview_div">
            <header class="mob-display common--header header--overide">
                <b-row class="dev_lr_margin">
                    <b-col cols="10" v-if="store.isLogoAvailable">
                        <img :src="store.groupDetail.cssp" alt class="img-responsive-class" style="max-height: 70px" />
                    </b-col>
                    <b-col cols="10" v-if="!store.isLogoAvailable">
                        <p class="app-header-title">{{ store.groupDetail.gnm }}</p>
                    </b-col>
                    <b-col cols="2" v-on:click="gomenu()" class="centering-block">
                        <img src="images/menu.png" alt />
                    </b-col>
                </b-row>
            </header>

            <header class="desk_display">
                <div id="header_content" class="common--header header--overide">
                    <p class="alignleft" v-if="store.isLogoAvailable">
                        <img :src="store.groupDetail.cssp" alt class="img-responsive-class" style='max-height:70px;' />
                    </p>
                    <p class="alignleft app-header-title line_height" v-if="!store.isLogoAvailable">
                        {{ store.groupDetail.gnm }}</p>
                    <p class="aligncenter header-title"></p>
                    <p class="alignright desk_menu_style">
                        <img src="images/Menu_QA@2x.png" alt v-b-toggle.sidebar-backdrop />
                    </p>
                </div>
                <div style="clearaligncenter: both"></div>
            </header>

            <b-container class="bv-example-row viewapt_height">
                <b-row align-h="center" class="row_height">
                    <b-col class="col-sm-12 col-md-5 col_padding dev_position">
                        <div class="text-center">
                            <p class="whatsnew_title">{{ this.whatsnew }}</p>
                            <div>
                                <div class="whatsnew_content whatsnew_cont_font" v-if="!showNoMsg">
                                    <div class="whatsnew_notification whatsnew_cont_font">
                                        <div v-for="item in whatsnewMsg" v-bind:key="item._id" :id="item._id">
                                            <label class="whatsnew_time">{{ item.cron }}</label>
                                            <label class="whatsnew_message">{{ item.msg }}</label>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="showNoMsg" class="whatsnew_content whatsnew_cont_font">
                                    <label class="whatsnew_next_schedule">{{ noWhatsNewMsg }}</label>
                                </div>
                                <div v-if="store.isAppointment">
                                    <b-row>
                                        <p class="whatsnew_next_schedule">{{ nextScheduledTest }}</p>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="7">
                                            <img src="images/Calender_Icon.svg" />
                                            <label class="whatsnew_title whatsnew_schedule">{{ dateValue }}</label>
                                        </b-col>
                                        <b-col cols="16">
                                            <img src="images/time_Icon.svg" />
                                            <label class="whatsnew_title whatsnew_schedule">{{ timeValue }}</label>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <label class="whatsnew_title whatsnew_venue">{{ venue }}</label>
                                        </b-col>
                                    </b-row>
                                </div>
                                <div v-if="!store.isAppointment">
                                    <b-row>
                                        <p class="whatsnew_next_schedule">{{ noApptMsg }}</p>
                                    </b-row>
                                </div>
                            </div>
                        </div>
                        <div class="desk_display alignButtonToBottom">
                            <b-container>
                                <label v-if="errorStatus" class="login_errorMessageLabel" id="errorLabel">{{ errorMessage }}</label>
                                <b-row>
                                    <div class="btn-container_SpaceAdjusted text-center" hidden>
                                        <a href="javascript:void(0);" @click="healthSurvey" id="survey" class="app--btn_healthSurvey"
                                            >HEALTH SURVEY</a
                                        >
                                    </div>
                                </b-row>
                                <b-row>
                                    <div class="btn-container_SpaceAdjusted text-center" hidden>
                                        <a href="javascript:void(0);" @click="resources" class="app--btn">RESOURCES</a>
                                    </div>
                                </b-row>
                            </b-container>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
            <div class="mob-display alignButtonToBottom">
                <b-container>
                    <label v-if="errorStatus" class="login_errorMessageLabel" id="errorLabel">{{ errorMessage }}</label>
                    <b-row>
                        <div class="btn-container_SpaceAdjusted text-center" hidden>
                            <a
                            href="javascript:void(0);"
                            @click="healthSurvey"
                            id="surveymobile"
                            class="app--btn_healthSurvey"
                            >HEALTH SURVEY</a>
                        </div>
                    </b-row>
                    <b-row>
                        <div class="btn-container_SpaceAdjusted text-center" hidden>
                            <a href="javascript:void(0);" @click="resources" class="app--btn">RESOURCES</a>
                        </div>
                    </b-row>
                </b-container>
            </div>
            <b-modal ref="healthsurvey-modal" class="verticalCenterAlign" centered hide-header hide-footer>
                <label class="thankyouText"
                    >The Health Survey is a feature that is available only from {{ this.store.mintodaytime12hrsFormate }} to
                    {{ this.store.maxtodaytime12hrsFormate }} for use. Please contact your group administrator for more details.<br /><br
                /></label>
                <div style="text-align: center">
                    <a href="javascript:void(0);" @click="hideModal" class="exitHyperLinkStyle">{{ this.ok }}</a>
                </div>
            </b-modal>
        </div>
        <Footer></Footer>
    </body>
</template>

<script>
import apiCall from "@/services/api/apicall";
import { store } from "@/store.js";
import moment from "moment";
import Footer from "@/components/footer";

export default {
    name: "Home",
    components: {
        Footer,
    },
    data: () => ({
        store: store,
        dateValue: "",
        timeValue: "",
        venue: "",
        noApptMsg: "",
        errorStatus: false,
        errorMessage: "",
        fcmTokenData: {},
        whatsnewMsg: [],
        showNoMsg: false,
        noWhatsNewMsg: "",
        appSurveyBtnColor: "",
    }),
    methods: {
        gomenu() {
            this.$router.push({ path: "/side-menu" });
        },

        healthSurvey() {
            // if (window.localStorage.getItem("enableHealthSurvey") == "true") {
            if (this.store.enableHealthSurvey) {
                this.$router.push({ path: "/symptom-chk" });
            } else {
                this.$refs["healthsurvey-modal"].show();
            }
        },

        resources() {
            this.$router.push({ path: "/resources" });
        },

        hideModal() {
            this.$refs["healthsurvey-modal"].hide();
        },

        sendToken() {
            let header = {};
            //     headers: [
            //         {
            //             key: "Content-Type",
            //             value: "application/json",
            //             type: "text",
            //         },
            //     ],
            // };

            apiCall
                .apiServiceCall("Post", "", "/nfc", this.fcmTokenData, header)
                .then((response) => {
                    if (response.status == 401) {
                        setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                    } else if (response.status == 504) {
                        this.$router.push({ path: "/login" });
                        //this.signout();
                    } else {
                        if (response.data.status == 1) {
                            console.log("Token Added");
                        }
                    }
                })
                .catch((error) => {
                    if (error.response.status == 504) {
                        this.$router.push({ path: "/login" });
                    } else if (error.response.status == 401) {
                        setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                    }
                    console.log(error);
                });
        },

        getNotoficationMsg() {
            apiCall
                .apiServiceCall("Get", "", "/nfc/msg", "", "")
                .then((response) => {
                    if (response.status == 500) {
                        this.errorStatus = true;
                        this.errorMessage = this.serverProblem;
                    } else if (response.status == 401) {
                        setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                    } else if (response.status == 504) {
                        this.signout();
                    } else {
                        if (response.data.status == 1) {
                            if (response.data.data.length > 0) {
                                this.whatsnewMsg = [];
                                this.showNoMsg = false;
                                for (var i = 0; i < response.data.data.length; i++) {
                                    this.whatsnewMsg.push({
                                        cron: moment(String(response.data.data[i].cron.split("T")[0])).format("M/D/YYYY"), //2020-09-04T12:05:34.707Z
                                        // cron: moment(response.data.data[i].cron).format("M/D/YYYY"),//CA-465
                                        msg: response.data.data[i].msg,
                                        _id: response.data.data[i]._id,
                                    });
                                }
                            } else {
                                var msg = response.data.message;
                                if (msg.includes("No Notification for you, today")) {
                                    this.showNoMsg = true;
                                    this.noWhatsNewMsg = "";
                                } else {
                                    this.showNoMsg = true;
                                    this.noWhatsNewMsg = response.data.message;
                                }
                            }
                        } else {
                            this.showNoMsg = true;
                            this.noWhatsNewMsg = response.data.message;
                        }
                    }
                })
                .catch((error) => {
                    if (error.response.status == 500) {
                        this.showNoMsg = true;
                        this.noWhatsNewMsg = this.serverProblem;
                    } else if (error.response.status == 401) {
                        setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                    } else if (error.response.status == 504) {
                        this.signout();
                    } else {
                        this.showNoMsg = true;
                        this.noWhatsNewMsg = error.response.data.message;
                    }
                });
        },

        get59ColorCode() {
            apiCall
                .apiServiceCall("Update", "", "/group/suvytme", "", "")
                .then((response) => {
                    if (response.status == 500) {
                        this.errorStatus = true;
                        this.errorMessage = this.serverProblem;
                    } else if (response.status == 401) {
                        setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                    } else if (response.status == 504) {
                        this.signout();
                    } else {
                        if (response.data.status == 1) {
                            this.showNoMsg = false;
                            this.store.hideHealthSurvey = response.data.data.suclr;
                            this.store.mintodaytime = response.data.data.susttme;
                            this.store.maxtodaytime = response.data.data.suentme;
                            this.store.mintodaytime12hrsFormate = this.formate24hrsTo12hrs(response.data.data.susttme);
                            this.store.maxtodaytime12hrsFormate = this.formate24hrsTo12hrs(response.data.data.suentme);

                            // ToDo
                            // this.store.mintodaytime = "13:00";
                            // this.store.maxtodaytime = "20:03";

                            if (this.store.hideHealthSurvey) {
                                var hour = moment(new Date()).format("HH:mm");
                                if (hour >= this.store.mintodaytime && hour <= this.store.maxtodaytime) {
                                    apiCall
                                        .apiServiceCall("Get", "", "/survey", "", "")
                                        .then((response) => {
                                            if (response.status == 500) {
                                                this.errorStatus = true;
                                                this.errorMessage = this.serverProblem;
                                            } else if (response.status == 401) {
                                                setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                                            } else if (response.status == 504) {
                                                this.signout();
                                            } else {
                                                if (response.data.status == 1) {
                                                    //User already submitted Health Survey for today
                                                    document.getElementById("survey").style.borderColor = "green";
                                                } else {
                                                    //User have not submitted Health Survey for today
                                                    document.getElementById("survey").style.borderColor = "darkred";
                                                }
                                            }
                                        })
                                        .catch((error) => {
                                            if (response.status == 504) {
                                                this.signout();
                                            } else if (response.status == 500) {
                                                this.errorStatus = true;
                                                this.errorMessage = this.serverProblem;
                                            } else if (response.status == 401) {
                                                setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                                            }
                                            console.log(error.response.data.message);
                                        });

                                    window.localStorage.setItem("enableHealthSurvey", true);
                                    this.store.enableHealthSurvey = true;
                                } else {
                                    //Health Survey option is not availabe for this time period
                                    document.getElementById("survey").style.borderColor = "grey";
                                    document.getElementById("survey").style.color = "grey";
                                    document.getElementById("surveymobile").style.borderColor = "grey";
                                    document.getElementById("surveymobile").style.color = "grey";
                                    window.localStorage.setItem("enableHealthSurvey", false);
                                    this.store.enableHealthSurvey = false;
                                }
                            } else {
                                window.localStorage.setItem("enableHealthSurvey", true);
                                this.store.enableHealthSurvey = true;
                            }
                        } else {
                            // document.getElementById("survey").style.borderColor = "#63799b";
                            // document.getElementById("survey").style.color = "#63799b";
                            // this.showNoMsg = true;
                            // this.noWhatsNewMsg = response.data.message;
                        }
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status) {
                        switch (error.response.status) {
                            case 504: 
                                this.signout(); 
                                break;
                            case 500:
                                this.errorStatus = true;
                                this.errorMessage = this.serverProblem;
                                break;
                            case 401:
                                setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                                break;
                            default:
                                this.showNoMsg = true;
                                this.noWhatsNewMsg = error.response.data.message;
                                break;
                        }
                    } else {
                        this.errorStatus = true;
                        this.errorMessage = this.serverProblem + error.message;
                    }
                });
        },
        formate24hrsTo12hrs(time) {
            //Converting the time stamp from 24hours format to 12hours format
            var hours = parseInt(time.substring(0, 2));
            var min = String(time.substring(2, 5));
            var suffix = hours >= 12 ? " PM" : " AM";
            time = ((hours + 11) % 12) + 1 + min + suffix;
            return time;
        },
    },
    mounted() {
        // this.get59ColorCode();

        console.log("window.FirebasePlugin Loaded", window.FirebasePlugin);

        // var tokenExist = window.localStorage.getItem("mobileToken");

        // console.log("TokenExist", tokenExist);

        // if (window.FirebasePlugin || (tokenExist == "false")) {
        if (window.FirebasePlugin) {
            window.FirebasePlugin.getToken(
                function (token) {
                    // save this server-side and use it to push notifications to this device;
                    console.log("FCM Device Token: " + token);
                    store.deviceFCMToken = token;
                    // window.localStorage.setItem("mobileToken", "true");
                },
                function (error) {
                    console.error(error);
                }
            );

            // Get notified when a token is refreshed
            window.FirebasePlugin.onTokenRefresh(
                function (token) {
                    store.deviceFCMToken = token;
                    this.sendToken();
                },
                // .bind(this),
                function (error) {
                    console.error(error);
                }
            );

            // Get notified when the user opens a notification
            window.FirebasePlugin.onMessageReceived(
                function (message) {
                    this.getNotoficationMsg();
                    console.log("Message type: " + message.messageType);
                    if (message.messageType === "notification") {
                        console.log("Notification message received");
                        if (message.tap) {
                            console.log("Tapped in " + message.tap);
                            console.log("Id " + message.id);
                            if (message.id === "1") {
                                this.$router.push({ path: "/schedule_checker" });
                            } else if (message.id === "2") {
                                this.$router.push({ path: "/test-results" });
                            } else {
                                // this.$router.push({ path: "/symptom-chk" });
                            }
                        }
                    }
                }.bind(this),
                function (error) {
                    console.error(error);
                }
            );
        }

        if (store.groupDetail.gid) {
            this.fcmTokenData.gid = store.groupDetail.gid;
        }

        if (store.deviceFCMToken) {
            this.fcmTokenData.tid = store.deviceFCMToken;
            // this.fcmTokenData.did = store.deviceFCMToken;
            this.sendToken();
        }

        if (navigator.onLine) {
            apiCall
                .apiServiceCall("GetOne", "", "/appt", "", "")
                .then((response) => {
                    if (response.data.data.length > 0) {
                        if (response.data.status == 1) {

                            var mt = moment.utc(response.data.data[0].apton);

                            this.dateValue = mt.format('M/D/YYYY');
                            this.timeValue = mt.format('h:mm A');
                            this.venue = "Venue :  " + response.data.data[0].fc.name;

                            store.isAppointment = true;
                            store.appointmentDetail.date     = response.data.data[0].apton;
                            store.appointmentDetail.dateTime = this.dateValue + " " + this.timeValue;
                            store.appointmentDetail.location = response.data.data[0].fc.name;
                            store.appointmentDetail.gender   = response.data.data[0].uc.gndr;
                            store.appointmentDetail.old_fcid = response.data.data[0].fcid;

                            this.store.groupDetail.cssp = JSON.parse(window.localStorage.getItem("logo"));
                            this.store.groupDetail.gnm  = JSON.parse(window.localStorage.getItem("gnm"));

                        } else {
                            this.noApptMsg = response.data.message;
                            store.appointmentDetail.noApptMsg = response.data.message;
                            store.isAppointment = false;
                        }
                    } else {
                        this.noApptMsg = "No Test Appointment";
                        store.appointmentDetail.noApptMsg = "No Test Appointment";
                        store.isAppointment = false;
                    }
                })
                .catch((error) => {
                    if (error.response.status == 500) {
                        this.errorStatus = true;
                        this.errorMessage = this.serverProblem;
                    } else if (error.response.status == 401) {
                        setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                    } else if (error.response.status == 504) {
                        this.signout();
                    } else {
                        this.noApptMsg = error.response.data.message;
                        store.appointmentDetail.noApptMsg = error.response.data.message;
                        store.isAppointment = false;
                    }
                });
            this.getNotoficationMsg();
        } else {
            this.errorStatus = true;
            this.errorMessage = this.checkInternetConnection;
            this.store.isLoginError = true;
            this.store.loginErrorMsg = this.checkInternetConnection;
            this.$router.push({ path: "/login" });
        }
    },
};
</script>
